export const CHAR_COUNT_LIMIT = 132;
export const DATE_FORMAT = 'MM/DD/YYYY';
export const MONTH_FORMAT = 'MMMM';
export const TIME_FORMAT = 'HH:mm';
export const DATE_TIME_FORMAT = `${DATE_FORMAT} ${TIME_FORMAT}`;
export const MAX_BATCH_RECIPIENTS = 5000;
